import type { CustomerFormValues } from '../types/CustomerCardTypes';
import type { CreateBusinessRequest, AssociateBusinessRequest } from '../types/businessConversion.types';

export const mapFormValuesToCreateBusinessPayload = (
    formValues: CustomerFormValues,
    enableCorrectPhoneHandling: boolean
): CreateBusinessRequest => ({
    businessName: formValues.business?.legalName || '',
    firstName: formValues.firstName || '',
    middleName: formValues.middleName,
    lastName: formValues.lastName || '',
    suffix: formValues.suffix,
    email: formValues.email || '',
    emailAlternative: formValues.emailAlternative,
    phone: enableCorrectPhoneHandling ? formValues.cellPhone : formValues.phone,
    homePhone: formValues.homePhone,
    workPhone: formValues.workPhone,
    address: {
        streetAddress: formValues.streetAddress,
        streetAddress2: formValues.streetAddress2,
        city: formValues.city,
        state: formValues.state,
        zip: formValues.zip,
        county: formValues.county
    },
    billingAddress: {
        streetAddress: formValues.billingAddress?.streetAddress,
        streetAddress2: formValues.billingAddress?.streetAddress2,
        city: formValues.billingAddress?.city,
        state: formValues.billingAddress?.state,
        zip: formValues.billingAddress?.zip,
        county: formValues.billingAddress?.county
    }
});

export const mapFormValuesToAssociateBusinessPayload = (
    formValues: CustomerFormValues,
    enableCorrectPhoneHandling: boolean
): AssociateBusinessRequest => ({
    businessEntityId: formValues.business?.businessEntityId || '',
    firstName: formValues.firstName || '',
    middleName: formValues.middleName,
    lastName: formValues.lastName || '',
    suffix: formValues.suffix,
    email: formValues.email || '',
    emailAlternative: formValues.emailAlternative,
    phone: enableCorrectPhoneHandling ? formValues.cellPhone : formValues.phone,
    homePhone: formValues.homePhone,
    workPhone: formValues.workPhone,
    address: {
        streetAddress: formValues.streetAddress,
        streetAddress2: formValues.streetAddress2,
        city: formValues.city,
        state: formValues.state,
        zip: formValues.zip,
        county: formValues.county
    }
});
